import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AgGridColumn, AgGridAngular } from 'ag-grid-angular-legacy';
import { RowNode } from 'ag-grid-community';
import { QuoteService } from 'src/app/services/quote.service'
import { HelperService } from 'src/app/services/helper.service';
//import { Value } from 'src/app/core/helpers/value-helper';
import { filter, map } from 'rxjs/operators';
import { QuoteComponent } from './rfq/quote.component';
import { PaymentComponent } from './rtmp/payment.component';
import { QuoteApplicationStatus } from 'src/app/core/constants/status.constants';
import { AgGridHeaderTooltipComponent } from '../common/components/ag-grid-header-tooltip/ag-grid-header-tooltip.component';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})

export class QuotesComponent {
  @ViewChild('quoteComponent', { static: false }) quoteComponent: QuoteComponent;
  @ViewChild('paymentComponent', { static: false }) paymentComponent: PaymentComponent;

  public fgSearch: UntypedFormGroup;
  public applications: any = [];

  public quoteData: any = [];
  public paymentsData: any = [];
  public quoteGridColumns: AgGridColumn[] | any[] = [];
  public paymentGridColumns: AgGridColumn[] | any[] = [];

  constructor(private fb: UntypedFormBuilder, private quoteService: QuoteService, private helperService: HelperService,
    private router: Router) { }

  ngOnInit() {

    this.fgSearch = this.fb.group({
      quoteNumber: ['', Validators.compose([Validators.maxLength(50)])],
    });

    this.initializeQuoteGridColumns();
    this.initialisePaymentColumns();

    // load applications after 3 sec of loading the page - otherwise the page may look like hanging
    this.loadQuoteApplications("*");
    this.loadPayments();
  }

  public defaultColDef = {
    flex: 1,
    resizable: true,
    floatingFilter: true,
  };

  public pinnedRowStyle(params): any {
    if (params.node.rowPinned) {
      return { 'font-weight': 'bold' };
    }
  }

  private initializeQuoteGridColumns(): void {
    this.quoteGridColumns = [
      {
        headerName: 'Quote No.',
        headerComponent: AgGridHeaderTooltipComponent,
        headerComponentParams: {
          tooltipContext: {
            register: 'External',
            tab: 'Offsets Payment',
            section: 'Quotes',
            fieldName: 'Quote No.'
          }
        },
         field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 100
      },
      {
        headerName: 'Proponent name', field: 'applicantName', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      {
        headerName: 'Development name', field: 'developmentName', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      {
        headerName: 'Process status',
        headerComponent: AgGridHeaderTooltipComponent,
        headerComponentParams: {
          tooltipContext: {
            register: 'External',
            tab: 'Offsets Payment',
            section: 'Quotes',
            fieldName: 'Process status'
          }
        },
        field: 'status', sortable: true, filter: 'agTextColumnFilter', minWidth: 100,
        valueFormatter: (params) => {
          return params.data.status === "Draft"? " Draft quote ": params.data.status
        },
      },
      {
        headerName: 'Action Required',
        headerComponent: AgGridHeaderTooltipComponent,
        headerComponentParams: {
          tooltipContext: {
            register: 'External',
            tab: 'Offsets Payment',
            section: 'Quotes',
            fieldName: 'Action required'
          }
        },
         field: 'actionRequired', sortable: true, filter: 'agTextColumnFilter', minWidth: 100
      }
    ]
  }

  private initialisePaymentColumns(): void {
    this.paymentGridColumns = [
      {
        headerName: 'Payment No.', field: 'paymentNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
      },
      {
        headerName: 'Quote No.', field: 'quoteNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 125
      },
      {
        headerName: 'Proponent name', field: 'applicantName', sortable: true, filter: 'agTextColumnFilter', minWidth: 175
      },
      {
        headerName: 'Development name', field: 'developmentName', sortable: true, filter: 'agTextColumnFilter', minWidth: 200
      },
      {
        headerName: 'Process status',
        headerComponent: AgGridHeaderTooltipComponent,
        headerComponentParams: {
          tooltipContext: {
            register: 'External',
            tab: 'Offsets Payment',
            section: 'BCF Payments',
            fieldName: 'Process status'
          }
        },
        field: 'status', sortable: true, filter: 'agTextColumnFilter', minWidth: 100,
        valueFormatter: (params) => {
          return params.data.status === "Draft"? " Draft payment request ": params.data.status
        },
      }
    ]
  }

  public loadQuoteApplications(keyword: string) {

    this.quoteService.getQuoteApplicationsByUser(keyword)
      .pipe(map((response:any) => {
        response.link = "";
        return response;
      }))
      .subscribe(result => {
        this.quoteData = result;
      });

  }

  public loadPayments() {
    this.quoteService.getQuotePaymentByUser().subscribe(results => {
      this.paymentsData = results;
    });
  }

  createNewApplication() {
    this.router.navigate(['quotes/rfq'])
  }

  public onSelectQuoteItem(event) {
    const id = event.id;
    const statusCode = event.statusCode;
    if (statusCode==null || statusCode==undefined) {
      return;
    }
    /*if (statusCode == QuoteApplicationStatus.Issued || statusCode == QuoteApplicationStatus.Accepted
      || statusCode == QuoteApplicationStatus.PartiallyAccepted) {
      this.quoteComponent.open(id);
    }
    else {
      this.router.navigate([`quotes/rfq/${id}`])
    }*/
   if (statusCode != QuoteApplicationStatus.Draft ) {
      this.quoteComponent.open(id);
    }
    else {
      this.router.navigate([`quotes/rfq/${id}`])
    }
  }

  public onSelectPaymentItem(event) {
    const id = event.id;
    const paymentId = event.status === "Draft" ? 0 : event.paymentId;
    const quoteId = event.id;

    if(event.status !== "Draft") {
      this.paymentComponent.open(id, event.paymentNumber, paymentId, quoteId);
    }else {
            this.router.navigate([`quotes/rtmp/${id}`], { 
          state: { 
            paymentNumber: event.paymentNumber,
            paymentId: event.paymentId
          } 
        });      
    }
  }

  public clear() {
    this.quoteData = [];
    this.fgSearch.reset();

  }

  public search() {
    let keyword = this.fgSearch.controls['quoteNumber'].value;
    this.loadQuoteApplications(keyword);
  }


}
